module.exports = __webpack_public_path__ + "img/main-bg1.d8f92c9c.png";